import { z } from "zod";

import { LocationMapSchema } from "@widgets/contact-map-card";

import { TableBlockSchema } from "@shared/content-types";
import { ButtonBaseSchema } from "@shared/content-types/schemas/common.schema";
import { StrapiMediaSchema } from "@shared/content-types/schemas/media.schema";
import { TitleWithIconSchema } from "@shared/content-types/schemas/pageHero.schema";
import { MetaSchema } from "@shared/content-types/schemas/pagination.schema";
import { SeoSchema } from "@shared/content-types/schemas/seo.schema";

import { MerchSchema } from "@/_pages/merch/model/schemas";

export const ShopDataSchema = z.object({
  sizeTable: TableBlockSchema,
  contactMapSection: LocationMapSchema,
});

export const ShopItemsDtoSchema = z.object({
  data: z.array(MerchSchema).min(0),
  meta: MetaSchema,
});

export const HeroItemSchema = z.object({
  titleWithIcon: TitleWithIconSchema,
  description: z.string(),
  button: ButtonBaseSchema,
  backgroundImage: StrapiMediaSchema,
});

export const ShopPageSchema = z.object({
  id: z.number().int().positive(),
  documentId: z.string().min(1),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  publishedAt: z.string().datetime().optional(),
  title: z.string().min(1),
  hero: z.array(HeroItemSchema),
  contactMapSection: LocationMapSchema,
  seo: SeoSchema.optional().nullable(),
  popupTitle: z.string().min(1),
  popupDescription: z.string().min(1),
});
